// Display names for the widget version tags. The WIRE values (`dev` /
// `release`) are part of the API contract and never change; only what the user
// reads does. The intermediate `beta` ("Private-QA") tier was removed — tags
// are now just dev ("Private") and release ("Public").
export const TAG_LABELS = {
  dev: 'Private',
  release: 'Public',
};

export const TAG_LEGEND = {
  dev: 'Private — editor head, the latest snapshot you committed (only you)',
  release: 'Public — the version everyone sees in the public catalog',
};

export const tagLabel = (tag) => TAG_LABELS[tag] || tag;
